import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './OpenWhatsAppButton.css';

export function toWhatsAppDigits(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('55') && digits.length >= 12) return digits;
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  if (digits.length >= 12) return digits;
  return '';
}

/**
 * Abre o WhatsApp (ou WhatsApp Business) instalado com telefone e mensagem.
 * Usa https://wa.me — evita o aviso do navegador "Abrir WhatsApp?".
 */
export function openWhatsAppApp(phone, message = '') {
  const digits = toWhatsAppDigits(phone);
  if (!digits) return false;

  const text = encodeURIComponent(message || '');
  const url = `https://wa.me/${digits}?text=${text}`;
  const ua = navigator.userAgent || '';
  const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);

  if (isMobile) {
    // No celular, navega direto — o SO abre WhatsApp / Business sem o popup do protocolo whatsapp://
    window.location.assign(url);
    return true;
  }

  // Desktop: nova aba (abre app Desktop se instalado, senão WhatsApp Web)
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  return true;
}

/**
 * Botão reutilizável para abrir o WhatsApp App.
 *
 * @param {object} props
 * @param {string} props.phone - Telefone com DDI/DDD (ex.: +5511999999999)
 * @param {string} [props.message] - Mensagem pré-preenchida
 * @param {string} [props.label] - Texto do botão
 * @param {'primary'|'secondary'|'orange'|'ghost'} [props.variant]
 * @param {string} [props.className]
 * @param {boolean} [props.fullWidth]
 * @param {() => void} [props.onOpened]
 * @param {() => void} [props.onError]
 */
export default function OpenWhatsAppButton({
  phone,
  message = '',
  label = 'Abrir WhatsApp',
  variant = 'primary',
  className = '',
  fullWidth = false,
  disabled = false,
  onOpened,
  onError,
  type = 'button',
}) {
  const handleClick = () => {
    const ok = openWhatsAppApp(phone, message);
    if (ok) {
      onOpened?.();
      return;
    }
    onError?.();
  };

  return (
    <button
      type={type}
      className={[
        'open-whatsapp-btn',
        `open-whatsapp-btn--${variant}`,
        fullWidth ? 'open-whatsapp-btn--full' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={handleClick}
      disabled={disabled || !toWhatsAppDigits(phone)}
    >
      <FaWhatsapp size={16} aria-hidden />
      <span>{label}</span>
    </button>
  );
}
